import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-white to-brand-purple/5 py-20 lg:py-32">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23e2e8f0%22%20fill-opacity%3D%220.3%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%221%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-40"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Status Badge */}
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full border border-success/20 mb-8">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">Available for new projects</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl lg:text-6xl font-bold text-text-primary mb-6">
            Let's Build Something
            <span className="gradient-text block">Amazing Together</span>
          </h1>

          {/* Description */}
          <p className="text-xl text-text-secondary mb-8 leading-relaxed">
            Ready to turn your ideas into reality? I'm here to collaborate on your next project.
            <br className="hidden sm:block" />
            Whether you're a startup, enterprise, or fellow developer, let's connect.
          </p>

          {/* Quick Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg mx-auto mb-3">
                <Icon name="Clock" size={24} className="text-primary" />
              </div>
              <p className="text-sm text-text-muted">Response Time</p>
              <p className="font-semibold text-text-primary">Within 24 hours</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-12 h-12 bg-success/10 rounded-lg mx-auto mb-3">
                <Icon name="Globe" size={24} className="text-success" />
              </div>
              <p className="text-sm text-text-muted">Time Zone</p>
              <p className="font-semibold text-text-primary">GMT +5:30 (IST)</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-12 h-12 bg-brand-purple/10 rounded-lg mx-auto mb-3">
                <Icon name="Users" size={24} className="text-brand-purple" />
              </div>
              <p className="text-sm text-text-muted">Collaboration</p>
              <p className="font-semibold text-text-primary">Remote & Global</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;